import { isFunction, isBoolean } from "lodash";
import React, { Fragment } from "react";
import { Icon } from "@unite-us/ui";
function getColorClass(active, completed) {
  var iconBgColorClass = "bg-dark-grey",
    textColorClass = "text-dark-grey";
  if (active) {
    iconBgColorClass = "bg-dark-blue";
    textColorClass = "text-dark-blue";
  } else if (completed) {
    iconBgColorClass = "bg-action-blue";
    textColorClass = "text-action-blue";
  }
  return {
    iconBgColorClass: iconBgColorClass,
    textColorClass: textColorClass
  };
}
function Step(_ref) {
  var active = _ref.active,
    completed = _ref.completed,
    disabled = _ref.disabled,
    icon = _ref.icon,
    label = _ref.label,
    _onClick = _ref.onClick;
  var _getColorClass = getColorClass(active, completed),
    iconBgColorClass = _getColorClass.iconBgColorClass,
    textColorClass = _getColorClass.textColorClass;
  return /*#__PURE__*/React.createElement("button", {
    className: "flex items-center p-4 ".concat(disabled ? "cursor-default" : ""),
    onClick: function onClick(e) {
      if (!disabled) {
        _onClick(e);
      }
    },
    "aria-label": "Step ".concat(icon, ": ").concat(label),
    "aria-disabled": disabled
  }, completed ? /*#__PURE__*/React.createElement(Icon, {
    icon: "V2CheckCircle",
    color: "#4467AB",
    size: 24
  }) : /*#__PURE__*/React.createElement("div", {
    className: "text-white text-base flex items-center justify-center font-black w-6 h-6 rounded-full ".concat(iconBgColorClass)
  }, icon), /*#__PURE__*/React.createElement("span", {
    className: "font-black whitespace-no-wrap ml-2 text-base ".concat(textColorClass)
  }, label));
}
export default function Stepper(_ref2) {
  var steps = _ref2.steps,
    className = _ref2.className;
  var currentStep = steps.findIndex(function (s) {
    return isFunction(s.isActive) && s.isActive();
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, " flex justify-around items-center")
  }, steps.map(function (step, index) {
    var completed = isStepCompleted(steps[index], currentStep, index);
    var disabled = isStepDisabled(steps[index], currentStep);
    return /*#__PURE__*/React.createElement(Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(Step, {
      key: "step-".concat(index),
      active: index === currentStep,
      completed: completed,
      disabled: disabled || !completed,
      icon: index + 1,
      label: step.label,
      onClick: function onClick() {
        return step.onStepClick();
      }
    }), index < steps.length - 1 && /*#__PURE__*/React.createElement("div", {
      key: "divider-".concat(index),
      className: "h-px w-full bg-grey"
    }));
  }));
}
function isStepCompleted(step, currentStep, index) {
  if (isFunction(step.stepCompleted)) {
    return step.stepCompleted(currentStep);
  }
  if (isBoolean(step.stepCompleted)) {
    return step.stepCompleted;
  }
  return currentStep > index;
}
function isStepDisabled(step, currentStep) {
  if (isFunction(step.stepDisabled)) {
    return step.stepDisabled(currentStep);
  }
  if (isBoolean(step.stepDisabled)) {
    return step.stepDisabled;
  }
  return false;
}
//# sourceMappingURL=Stepper.js.map